import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { ADMIN_API_ENDPOINTS } from "../../common/api-endpoints";

export interface PaymentMethodDto {
  id: string;
  paymentType?: string;
  name?: string;
  enabled: boolean;
}

@Injectable({ providedIn: "root" })
export class PaymentMethodApiService {
  constructor(private readonly httpService: HttpService) {}

  async getList(): Promise<PaymentMethodDto[]> {
    const result = await this.httpService.get<PaymentMethodDto[] | { rows: PaymentMethodDto[] }>(
      ADMIN_API_ENDPOINTS.PAYMENT_METHODS
    );
    if (Array.isArray(result)) return result.map((p) => this.normalize(p));
    const rows = result?.rows ?? [];
    return rows.map((p) => this.normalize(p));
  }

  async update(id: string, payload: Partial<Pick<PaymentMethodDto, "enabled">>): Promise<PaymentMethodDto | null> {
    const updated = await this.httpService.put<PaymentMethodDto>(
      `${ADMIN_API_ENDPOINTS.PAYMENT_METHODS}/${id}`,
      payload
    );
    return updated ? this.normalize(updated) : null;
  }

  private normalize(raw: Partial<PaymentMethodDto>): PaymentMethodDto {
    const paymentType = raw.paymentType ?? raw.name ?? "";
    return {
      id: raw.id ?? "",
      paymentType,
      enabled: raw.enabled ?? false,
    };
  }
}
